module.exports = __webpack_public_path__ + "static/media/notes-active.7d886890.svg";